import { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./FieldCollection.css";
import FieldMonitoring from "./FieldMonitoring";

const FieldCollection = ({ changePage }) => {
  const [isOverviewShown, setIsOverviewShown] = useState(false);

  return (
    <div className="field-collection">
      <div className="list_header">
        <div className="list_headerLeft">
          <h1>Field Collection</h1>
        </div>
      </div>

      <div className="container-field-collection">
        <div className="container-monitoring">
          <header className="agent">
            <p>{isOverviewShown ? "Overview" : "Monitoring"}</p>

            {isOverviewShown ? (
              <Icon
                className="close-button"
                icon="ph:x-bold"
                height="28"
                width="28"
                onClick={() => setIsOverviewShown(false)}
              />
            ) : (
              <div onClick={() => setIsOverviewShown(true)}>
                <p>Overview</p>
                <Icon height="36" icon="mingcute:right-line" />
              </div>
            )}
          </header>

          <FieldMonitoring
            changePage={changePage}
            isOverviewShown={isOverviewShown}
          />
        </div>
      </div>
    </div>
  );
};

export default FieldCollection;
